import {remCalc} from '../../../_utils'

const minicartFooter = {
    MinicartFooter: {
        baseStyle: () => ({
            wrapperfooter: {
                w: '100%',
                gap: '0',
                color: 'color.border.black',
                textStyle: {base: 'paragraphSm', lg: 'paragraphMd'},
                fontWeight: '400',
                position: 'fixed',
                bottom: '0',
                right: '0',
                backgroundColor: 'color.background.white',
                px: {base: 'spacing.4', md: 'spacing.6'},
                pt: '0',
                pb: 'spacing.10',
            },

            subtotalSection: {
                w: '100%',
                gap: '0',
                justifyContent: 'space-between',
                letterSpacing: remCalc(4),
                pt: 'spacing.4',
                pb: 'spacing.10',
                borderTop: '1px solid',
                borderBottom: '1px solid',
                borderColor: 'color.border.drawer.default',
            },

            cartButton: {
                marginTop: 'spacing.8',
                textTransform: 'uppercase',
                fontWeight: '400',
                letterSpacing: remCalc(4),
            },

            expressSection: {
                w: '100%',
                gap: 'spacing.4',
                marginTop: 'spacing.4',
                letterSpacing: remCalc(0.6),
            },

            expressLabel: {
                textStyle: 'paragraphMd',
            },

            notice: {
                w: '100%',
                marginTop: 'spacing.2',
                textStyle: 'paragraphSm',
                fontWeight: '300',
                letterSpacing: remCalc(0.6),
            },
            expressPaypalBox: {
                w: '100%',
            },
            paypal_container: {
                width: '100%',
            },
        }),
        variants: {
            relativeFooter: {
                wrapperfooter: {
                    px: 'unset',
                    pt: 'unset',
                    pb: 'unset',
                    position: 'relative',
                },
            },
        },
    },
}

export default minicartFooter
